import up from 'unpoly';

import { fillUtmParams } from '../front/tracking.ts';

up.compiler('.js-form-fill-utm-tags', fillUtmParams);
